<script>
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'Renko',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.1.0',
                    desc: 'Renko Chart',
                    preset: {
                        name: 'Renko',
                        side: 'onchart',
                        settings: {
                            brickSize: 'auto',
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                if (!candles || candles.length === 0) return

                // Calculate brick size from ATR of visible data
                let brickSize = this.getBrickSize(candles)
                if (brickSize <= 0) return

                // Build Renko bricks from candle close prices. Bricks are spaced
                // as their own sequence so multiple bricks from one source candle
                // do not render on top of each other.
                let bricks = []
                let currentLevel = candles[0].raw[4]
                let step = this.getBrickStep(candles)
                let nextX = candles[0].x

                for (var i = 1, n = candles.length; i < n; i++) {
                    let close = candles[i].raw[4]
                    let diff = close - currentLevel

                    while (Math.abs(diff) >= brickSize) {
                        let direction = diff > 0 ? 1 : -1
                        let brickOpen = currentLevel
                        let brickClose = currentLevel + direction * brickSize
                        currentLevel = brickClose

                        bricks.push({
                            x: nextX,
                            w: step * 0.9,
                            open: brickOpen,
                            close: brickClose,
                            green: direction > 0
                        })

                        nextX += step
                        diff = close - currentLevel
                    }
                }

                // Render bricks
                for (var i = 0, n = bricks.length; i < n; i++) {
                    this.drawBrick(ctx, layout, bricks[i])
                }
            },
            drawBrick(ctx, layout, brick) {
                let color = brick.green ? this.upColor : this.downColor
                let w = Math.max(brick.w * 0.8, 1)
                let hw = Math.max(Math.floor(w * 0.5), 1)

                let yOpen = Math.floor(brick.open * layout.A + layout.B)
                let yClose = Math.floor(brick.close * layout.A + layout.B)
                let top = Math.min(yOpen, yClose)
                let height = Math.max(Math.abs(yClose - yOpen), 1)

                let bodyX = Math.floor(brick.x - hw - 1)
                let bodyW = Math.floor(hw * 2 + 1)

                ctx.fillStyle = color
                ctx.fillRect(bodyX, top, bodyW, height)

                // Border
                ctx.strokeStyle = color
                ctx.lineWidth = 1
                ctx.strokeRect(bodyX, top, bodyW, height)
            },
            getBrickSize(candles) {
                if (this.sett.brickSize && this.sett.brickSize !== 'auto') {
                    return parseFloat(this.sett.brickSize)
                }
                // Auto: use ATR-like calculation
                let sum = 0
                for (var i = 0, n = candles.length; i < n; i++) {
                    sum += candles[i].raw[2] - candles[i].raw[3]
                }
                let atr = sum / candles.length
                return atr * 0.5
            },
            getBrickStep(candles) {
                if (candles.length < 2) return Math.max(candles[0].w || 5, 5)
                let first = candles[0].x
                let last = candles[candles.length - 1].x
                let step = Math.abs(last - first) / Math.max(candles.length - 1, 1)
                return Math.max(step || candles[0].w || 5, 3)
            },
            use_for() { return ['Renko'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
